<template>
  <div class="follow_us">
    <div id="head-page" class="follow parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img class="" src="@/assets/images/head/globulo-follow.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.3"><img class=""  src="@/assets/images/head/bubble-follow.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class=""  src="@/assets/images/head/reseaux-follow.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="grid-container content-page">
      <div class="grid-x grid-container-padding">
        <div class="small-12 medium-6 cell">

        <title-page attrpage="Ne ratez pas les actualités de Globulo Quest" baseline="">Suivez-nous sur nos réseaux sociaux</title-page>

        <p><strong>Globulo Quest</strong> est une solution digitale d’accompagnement des enfants atteints de leucémie, gratuite, sous la forme d’une plateforme web et de mini-jeux en libre accès sur internet.</p>
        <p>Notre volonté est que chaque enfant atteint de leucémie puisse être accompagné par ses parents, ses soignants et ses proches dans <strong>la gestion de son quotidien et son parcours de soins.</strong> Apporter de la joie, de la complicité et de la réassurance à travers le jeu sont également des objectifs majeurs de <strong>Globulo Quest.</strong></p>

        <p>Notre travail prend tout son sens s’il profite à chaque personne malade concernée et aussi au plus grand nombre.</p>

        <p>Aidez-nous à faire connaitre et diffuser <strong>Globulo Quest</strong> pour que ce programme bénéficie à ceux qui en ont besoin.</p>

        <p>Depuis le début de notre projet, nous avons rencontré des personnes formidables qui croient comme nous en la quête d’une vie meilleure malgré la maladie.</p>

        <p><strong>Rejoignez-nous dans cette aventure</strong> en nous suivant sur nos réseaux sociaux, en partageant nos news et en nous faisant part de vos idées ou commentaires.</p>

        <p>Si vous souhaitez participer plus activement ou <strong>faire partie du Groupe de Travail Globulo Quest</strong>, n’hésitez pas à <router-link :to="{ name: 'contact_us' }" title="Contact Globulo Quest">nous contacter.</router-link></p>


          </br>
          </br>
        </div>

        <div class="small-12 medium-5 large-offset-1 cell show-for-large-only">
          <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FGlobuloQuest%2F&tabs=timeline&width=400&height=800&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=false&appId=425941467965178" width="400" height="800" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
        </div>

        <div class="small-12 medium-5 cell hide-for-large-only">
          <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FGlobuloQuest%2F&tabs=timeline&width=250&height=500&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=false&appId=425941467965178" width="250" height="500" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
        </div>

      </div>

      <!--
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-4 large-3 cell">
          <box-social lien="https://www.facebook.com/GlobuloQuest/" date="24 Dec. 2018" reseau="facebook">
            Joyeux Noël à tous !
            <br>
            Vivement 2019 et la sortie de la première version de notre solution digitale Globulo Quest pour aider les enfants atteints de leucémie dans leurs parcours de santé.
            A très bientôt.
            <br>
            La Globulo Team
          </box-social>
        </div>
        <div class="small-12 medium-4 large-3 cell">
          <box-social lien="https://www.facebook.com/GlobuloQuest/" date="15 Oct. 2018" reseau="facebook">
            1° ANNIVERSAIRE POUR GLOBULO QUEST !
            <br><br>
            Et oui, le temps passe vite. Cela va faire 1 an que nous nous sommes rencontrés lors du hackathon de la Fondation d'entreprise B. Braun...
          </box-social>
        </div>
      </div>
      -->
    </div>
  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import BoxSocial from '@/components/sidebar/BoxSocial'
  export default {
    components: { TitlePage, BoxSocial },
  }
</script>
